import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.555 2.346a1 1 0 0 1 .89 0l7.314 3.657L17 7.382l-7.759-3.88zm-5.086.306L2.665 4.554l-.001.001A3 3 0 0 0 1 7.24v9.518a3 3 0 0 0 1.65 2.696l.003.001 8 4a3 3 0 0 0 2.684 0l7.998-3.998.001-.001A3 3 0 0 0 23 16.771V7.24a3 3 0 0 0-1.664-2.685h-.001l-7.998-4-.447.895.445-.896a3 3 0 0 0-2.67 0l-.002.002-4.024 2.011q-.089.035-.17.085m.536 1.969L14.764 8.5 12 9.882l-7.759-3.88zm10.434 4.778L13 11.618v9.769l7.443-3.721.002-.002A1 1 0 0 0 21 16.77V7.62l-3.543 1.77zM3 7.618v9.149a1 1 0 0 0 .55.9L11 21.392v-9.774z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }